import { ContactDto } from '../contact.dto';
import { ContactType } from '../enums';
import { BankDto, BrokerDto, IndividualDto, LegalEntityDto } from '../types';

export const isBankContact = (data: ContactDto): data is BankDto => {
  return data.type === ContactType.BANK;
};

export const isBrokerContact = (data: ContactDto): data is BrokerDto => {
  return data.type === ContactType.BROKER;
};

export const isIndividualContact = (data: ContactDto): data is IndividualDto => {
  return data.type === ContactType.INDIVIDUAL;
};

export const isLegalEntityContact = (data: ContactDto): data is LegalEntityDto => {
  return data.type === ContactType.LEGAL_ENTITY;
};

export const isContactType = (type: string): type is ContactType =>
  Object.values(ContactType).includes(type as ContactType);

export const getContactFilepaths = (contact: ContactDto) => {
  const filepaths = [contact.photo, contact.businessCardFile]
    .flat()
    .filter((filePath) => filePath !== undefined);

  return filepaths;
};
